<template>
  <div class="box grow flex" @click="$emit('click')">
    <div class="box grow flex column justify-center p-10 info">
        <span style="margin-bottom:10px;">
          <status-indicator class="ml-10"
            :positive="positive"
            :intermediary="intermediary"
            :negative="negative"
            pulse
          />
          <span style="margin-bottom:10px;">
            <i v-if="!qtyValid" class="mdi mdi-alert ml-5">&nbsp;</i> {{customerName(customer)}}
          </span>
          <el-tag v-for="t in tags" :key="t.id">{{t.code}}</el-tag>
        </span>

        <span class="fs-14 secondary-text" style="margin-left:5px;margin-bottom:3px;">{{so_number}} <span v-if="reference"> ({{reference}})</span></span>
        <span class="fs-14 secondary-text" style="margin-left:5px;margin-bottom:3px;" v-if="date">{{moment(date)}}</span>
        <span v-if="sales_rep" class="fs-14 secondary-text" style="margin-left:5px;margin-bottom:3px;">{{sales_rep.firstName}} {{sales_rep.lastName}}</span>
    </div>
    <div class="overdue flex p-10" style="flex-direction:column">
      <span class="" style="text-align:right;">{{$n(total,'currency')}}</span>
      <SalesOrderStatusTag :status="status" />
    </div>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import customerUtil from '@/utils/customer-util'
import SalesOrderStatusTag from '@/views/pages/salesOrder/components/sales-order-status-tag'

export default {
  name: 'Sales-order-tile',
	props: {
    customer : {
      type : Object,
      require : true
    },
    shipping_contact : {
      type : Object,
      require : true
    },
    so_number : {
      type : String
    },
    reference : {
      type : String
    },
    date : {
      type : String
    },
    total : {
      type : Number
    },
    status : {
      type : Object,
      require : true
    },
    sales_rep : {
      type : Object
    },
    positive : Boolean,
    intermediary : Boolean,
    negative : Boolean,
    tags : Array,
    lines : Array,
	},
  data() {
    return {
    };
  },components: {
    SalesOrderStatusTag
  },
	methods: {
    customerName(customer){
      if (customer == null) return null;
      return customerUtil.customerName(customer.name, customer.usualName);
    },
    moment(datetime){
      return  moment(datetime).format('LL');
    }
	},
  computed : {
    qtyValid (){
      let valid = true;
      if (_.isEmpty(this.lines)) return valid;
      _.forEach(this.lines, l=> {
        if (l.quantityAvailable === false) valid = false
      })
      return valid;

    },
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';



</style>
